const initialState = () => ({
  identity: {},
  profile: {},
  aboutyou: {},
  contact: {},
  teamprofile: {},
  invitations: []
})

export default api => ({
  namespaced: true,

  state: initialState,

  getters: {
    identity: state => state.identity,
    profile: state => state.profile,
    aboutyou: state => {
      const { photo, nickname, pronoun, facts } = state.profile
      return Object.assign({}, { photoUrl: photo, nickname, pronoun, facts }, state.aboutyou)
    },
    contact: state => {
      const { timezone, bestTime, canCall, canEmail, canTalk, canText, canVideo, canSlack, canZoom, canHangout } = state.profile
      return Object.assign({}, { timezone, bestTime, canCall, canEmail, canTalk, canText, canVideo, canSlack, canZoom, canHangout }, state.contact)
    },
    teamprofile: state => state.teamprofile,
    invitations: state => state.invitations
  },

  mutations: {
    updateIdentity: (state, identity) => {
      state.identity = identity
    },

    updateProfile: (state, profile) => {
      state.profile = profile
    },

    updateAboutYou: (state, aboutyou) => {
      state.aboutyou = aboutyou
    },

    clearAboutYou: state => {
      state.aboutyou = {}
    },

    updateContact: (state, contact) => {
      state.contact = contact
    },

    clearContact: state => {
      state.contact = {}
    },

    updateTeamProfile: (state, teamprofile) => {
      state.teamprofile = teamprofile
    },

    updateInvitations: (state, invitations) => {
      state.invitations = invitations
    },

    clearInvitations: state => {
      state.invitations = []
    },

    resetSignUp: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    managerSignUp: async ({ commit }, data) => {
      const result = await api.managerSignUp(data)
      const { user, ...other } = result
      commit('updateIdentity', user)
      commit('updateProfile', other)
    },

    teamMemberSignUp: async ({ commit }, data) => {
      const result = await api.teamMemberSignUp(data)
      const { user, ...other } = result
      commit('updateIdentity', user)
      commit('updateProfile', other)
    },

    fetchProfileSignUp: async ({ commit }) => {
      const result = await api.fetchProfileMe()
      const { user, ...other } = result
      commit('updateIdentity', user)
      commit('updateProfile', other)
    },

    createAboutYou: ({ commit }, data) => {
      commit('updateAboutYou', data)
    },

    clearAboutYou: ({ commit }) => {
      commit('clearAboutYou')
    },

    createContact: ({ commit }, data) => {
      commit('updateContact', data)
    },

    clearContact: ({ commit }) => {
      commit('clearContact')
    },

    createTeamProfile: ({ commit }, data) => {
      commit('updateTeamProfile', data)
    },

    createInvitations: ({ commit }, data) => {
      commit('updateInvitations', data.filter(Boolean))
    },

    clearInvitations: ({ commit }) => {
      commit('clearInvitations')
    },

    clear: ({ commit }) => {
      commit('resetSignUp')
    }
  }
})
